export interface Classification {
  identifier: string;
  name: string;
  nameEng: string;
  parentId: string;
  level: number;
  description?: string;
  descriptionEng?: string;
}

export enum ClassificationTypes {
  FO = 'FO2011',
  BO = 'BO',
  PO = 'PO2015',
}

export interface ClassificationChoosenAnswer {
  identifier: string;
  order: number;
  nameSv: string;
  nameEn: string;
}

export interface ClassificationTypeAnswer {
  typeId: string;
  choosenItems: ClassificationChoosenAnswer[];
}

export interface DescriptionItems {
  identifier: string;
  parentId: string;
  level: number;
  name: string;
  nameEng: string;
  isExpanded: boolean;
  description: string;
  descriptionEng: string;
  children: DescriptionItems[];
}

export interface ClassificationAnswer {
  BO: ClassificationTypeAnswer;
  FO: ClassificationTypeAnswer;
  PO: ClassificationTypeAnswer;
}
